import { mapGetters } from 'vuex'
import { EventBus, EVENTS } from '@/services/event-bus'
import { MESSAGE_TYPES } from '@/stores/flash'

const CYCLON_PLAN_NAME = 'Cyclon'
const CYCLON_PLAN_CODE = 'cyclon'

function getLineItems(items) {
  return items.map(item => {
    const lineItem = {
      sku: item.variantSku,
      productSku: item.masterSku,
      productName: item.productName,
      productType: item.productType,
      price: item.price,
      currency: item.currency,
      quantity: item.quantity,
      size: item.displaySize,
    }
    return lineItem
  })
}

export default {
  computed: {
    ...mapGetters({
      currentUser: 'account/currentUser',
    }),
  },

  methods: {
    updateCart(
      { selectedSku, variantId = '' },
      { context = this.$CONTEXTS.unknown, isGiftCardOrder = false, giftCardMessage = '' } = {}
    ) {
      if (context !== this.$CONTEXTS.quickView)
        this.$store.dispatch('nav/setAdditionalNav', 'mini-cart')
      this.$store.dispatch('order/updateServer', {
        skuId: selectedSku.productVariantId,
        quantity: 1,
        isGiftCardOrder,
        giftCardMessage,
        onError: this.showAddToCartError,
        onDone: order => {
          const lineItems = getLineItems(order.items)
          const addedItem = lineItems.filter(lineItem => lineItem.sku == selectedSku.sku)[0]
          this.trackAddToCart(lineItems, { ...addedItem, variantId }, { context })
          this.dispatchAddToCartEvents()
        },
      })
    },

    addItemToSubscriptionOrder({ currency, country, price, id, sku, name, imageUrl, color, size }) {
      const quantity = 1
      this.$store.dispatch('nav/setAdditionalNav', 'mini-cart')

      const subscriptionOrder = {
        email: this.currentUser?.email || '',
        currency,
        country,
        planCode: CYCLON_PLAN_CODE,
        planName: CYCLON_PLAN_NAME,
        quantity,
        tax: 0,
        discount: 0,
        subtotal: price,
        total: price,
        items: [
          {
            sku,
            name,
            imageUrl,
            details: [color, size],
            quantity,
            id,
          },
        ],
      }
      this.$store.dispatch('order/addItemToSubscriptionOrder', {
        subscriptionOrder,
        onError: this.showAddToCartError,
        onDone: this.dispatchAddToCartEvents,
      })
    },

    trackAddToCart(lineItems, addedItem, { context } = {}) {
      this.$notifier.trackEvent({
        action: this.$notifier.ACTIONS.addToCart,
        product: {
          ...addedItem,
          viewmode: context === this.$CONTEXTS.quickView ? this.$CONTEXTS.quickView : '',
        },
      })
      this.$dyClient.trackAddToCart(lineItems, addedItem)
      if (context === this.$CONTEXTS.miniCart) this.$dyClient.trackMinicartAddToCart(addedItem)
    },

    showAddToCartError(message) {
      const text = message || this.$t('minicart.cart_add_fail')
      this.$store.dispatch('flash/addMessage', {
        text,
        type: MESSAGE_TYPES.error,
        context: this.$CONTEXTS.miniCart, // always show errors in mini cart context
      })
    },

    dispatchAddToCartEvents() {
      window.dispatchEvent(new CustomEvent('on:addtocart'))
      EventBus.$emit(EVENTS.minicart.update, { detail: { addToCart: true } })
    },
  },
}
